interface PageParams {
    pathname: string;
    generalKeys: string[];
    tabs: string[];
    theme?: string;
    sites: string[];
}

export const pageParams: PageParams = {
    pathname: 'stream-extra-battery-series',
    generalKeys: ['product_bk623', 'product_bk625'],
    tabs: ['product', 'Spec', 'support'],
    theme: 'white',
    sites: ['eu', 'de', 'fr', 'it', 'es', 'uk'],
};

export const pathname = pageParams.pathname;
export const generalKeys = pageParams.generalKeys;
export const tabs = pageParams.tabs;
export const theme = pageParams.theme;
export const sites = pageParams.sites;
